<template>
    <div class="cardBorder mt-40">
        <h5>主要包含如下内容</h5>
      <!--          图片模版相同时-->
      <div v-if="type == null" class="content">
        <div class="list" v-for="(item,index) in h6" :key="index">
          <h6>{{item}}</h6>
          <div v-show="msg[index]">
            <div v-if="Array.isArray(msg[index])">
              <p v-for="(item,index) in msg[index]" :key="index">
                {{item}}
                <br>
              </p>
            </div>
            <div v-else>
              <p>
                {{msg[index]}}<span style="color: #7f7f7f" v-if="tip">{{ tip[0] }}</span>
              </p>
            </div>
            <p style="color: #7f7f7f" v-if="index == 7 && tip">{{ tip[1] }}</p>
          </div>
          <el-row :gutter="24" v-show="img?true:false">
            <!-- <el-col :xs="12" :sm="8" style="margin-top:1rem">
                <div class="imgLimit"><img v-show="img?true:false" :src="img[index*2]" alt=""></div>
            </el-col> -->
            <el-col :xs="12" :sm="8" style="margin-top:1rem" v-for="(item,i) in img[index]" :key="i">
              <!-- <div  class="imgLimit"><img v-show="img?true:false" :src="img[index*2+1]" alt=""></div> -->
              <div class="imgLimit"><img v-show="img?true:false" :src="item" alt=""></div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--          图片模版不同时-->
      <div v-else class="content">
        <div class="list" v-for="(item,index) in h6" :key="index">
          <h6>{{item.title}}</h6>
          <el-row :gutter="16">
            <el-col :class="'col_' + item.num" style="margin-top:1rem" v-for="(iem,i) in item.imgUrl" :key="i">
              <div class="imgLimit"><el-image lazy :preview-src-list="item.imgUrl" :src="iem" alt=""/></div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props:['h6','msg','img','type','tip']
}
</script>

<style lang="scss" scoped>
.cardBorder{
    padding-bottom: vw(32);
    border: 2px solid $yyBlue;

  ::v-deep .el-image img{
    object-fit: cover;
  }

    h5,h6{
        margin: 0;
    }

    h5,h6{
        font-size: vw(16);
    }

    h5{
        padding: vw(16) 0;
        color: white;
        background: $yyBlue;
    }

    .content{
        padding: 0 vw(36);
        h6{
            position: relative;
            margin-left: vw(32);
            padding-top: vw(30);
            text-align: left;
            color: $yyBlue;

            &::before{
                content: '';
                position: absolute;
                height: vw(18);
                width: vw(18);
                // top: 0;
                left: vw(-31);
                background: $yyBlue;
                border-radius: 50%;
            }
        }
        p{
            font-size: vw(16);
            margin-bottom: 0;
            text-indent: vw(32);
            text-align: left;
            // white-space: pre-wrap;
        }
        .col_3 {
          width: 12.5vw;
          ::v-deep .el-image{
            width: 11.78vw;
            height: 11.78vw;
          }
        }
        .col_5 {
          width: 7.5vw;
          ::v-deep .el-image{
            width: 6.47vw;
            height: 6.47vw;
          }
        }
        .imgLimit{
            display: inline;
            width: vw(196);
            height: vw(133);

            img{
                width: 100%;
                height: 100%;
            }
        }

        ::v-deep {
            .el-row{
                padding-left: vw(32);
            }
        }
    }

    // -------------------------------  手机端  -------------------------------

    @media only screen and (max-width: 767px){
        margin-left: vw(-38);
        margin-right: vw(-38);
        border: 0;

        h5{
            font-size: vp(36);
            padding: vp(28) 0;
        }
        .content{
            h6{
                font-size: vp(30);
                margin-left: vp(68);
                padding-top: vp(30);
                // line-height: 1.8;

                &::before{
                    height: vp(18);
                    width: vp(18);
                    left: vp(-38);
                    top: 50%;
                }
            }

            p{
                font-size: vp(24) !important;
                text-indent: vp(50);
            }
          .col_3 {
            width: 50%;
            ::v-deep .el-image{
              width: 40vw;
              height: 40vw;
            }
          }
          .col_5 {
            width: 50%;
            ::v-deep .el-image{
              width: 40vw;
              height: 40vw;
            }
          }
        }
        
    }

    

}
</style>